<script setup lang="ts">
const { content } = defineProps<{
  content?: string
}>()
</script>

<template>
  <h1 class="text-2xl md:text-3xl text-primary">
    <slot>
      {{ content }}
    </slot>
  </h1>
</template>
